import SpeechRecognition from "react-speech-recognition";

export const startListening = (langSelected) => { SpeechRecognition.startListening({ continuous: true, language: langSelected }) };
export const stopListening = () => SpeechRecognition.stopListening();

export const handleSpeak = async (label, langSelected, voiceSelected, getActiveState, onBtnRef, name) => {
  

  try {
    let gend='Male';
    if (langSelected === 'pa-IN') {
      gend='Female';
      voiceSelected='pa-IN-OjasNeural';
    }else if(langSelected === 'ml-IN'){
      gend='Female';
      voiceSelected='ml-IN-MidhunNeural';
    }else if(langSelected === 'kn-IN'){
      gend='Female';
      voiceSelected='kn-IN-GaganNeural';
    }else if(langSelected==='or-IN'){
      gend='Male';
      voiceSelected="or-IN-SukantNeural";
    }

    const response = await fetch("https://anuvadini-services.aicte-india.org/api/text-to-speech", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer a6b5c4d3e2f1g7h8i9j0k1l2m3n4o5p6"
      },
      body: JSON.stringify({
        text: name,
        lang: langSelected,
        languageVoice: voiceSelected,
        gender:gend
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();
    // const audioData = responseData.audio;
    function base64ToUint8Array(base64) {
      const binaryString = window.atob(base64); // Decode Base64
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
  
      for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
      }
  
      return bytes;
  }

  const base64Audio = responseData.audio;
  
  // Decode Base64 audio data
  const audioData = base64ToUint8Array(base64Audio);

    const audioBlob = new Blob([audioData], { type: "audio/wav" });
    const audioUrl = URL.createObjectURL(audioBlob);
    const audio = new Audio(audioUrl);

      

    if (label.toLowerCase() === getActiveState.current.toLowerCase()) {
      audio.play();
      onBtnRef.current = false;
      const checkActiveInterval = setInterval(() => {
        if (label.toLowerCase() !== getActiveState.current.toLowerCase()) {
          clearInterval(checkActiveInterval);
          audio.pause();
          onBtnRef.current = true;
          audio.currentTime = 0; // Reset audio to the beginning
        }
      }, 100);
    }

    audio.onended = () => {
      onBtnRef.current = true;
      if (name === 'contact_email' || name === 'email' 
        || label === 'contact_email' || label === 'email'
      ) {startListening('en-IN');}
      else {startListening(langSelected);}
    };
  } catch (error) {
    console.error("Error in TTS request:", error);
  }

};

export const handleSpeakWithoutVoice = async (label, langSelected, voiceSelected, getActiveState, name) => {

  try {
    const response = await fetch("https://anuvadini-services.aicte-india.org/api/text-to-speech", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Authorization": "Bearer a6b5c4d3e2f1g7h8i9j0k1l2m3n4o5p6"
      },
      body: JSON.stringify({
        text: name,
        lang: langSelected,
        languageVoice: voiceSelected,
        gender:'Male'
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }

    const responseData = await response.json();
    // const audioData = responseData.audio;
    function base64ToUint8Array(base64) {
      const binaryString = window.atob(base64); // Decode Base64
      const len = binaryString.length;
      const bytes = new Uint8Array(len);
  
      for (let i = 0; i < len; i++) {
          bytes[i] = binaryString.charCodeAt(i);
      }
  
      return bytes;
  }

  const base64Audio = responseData.audio;
  
  // Decode Base64 audio data
  const audioData = base64ToUint8Array(base64Audio);

    const audioBlob = new Blob([audioData], { type: "audio/wav" });
    const audioUrl = URL.createObjectURL(audioBlob);
    const audio = new Audio(audioUrl);

      // audio.play();

    audio.play();

    const checkActiveInterval = setInterval(() => {
      if (label.toLowerCase() !== getActiveState.current.toLowerCase()) {
        clearInterval(checkActiveInterval);
        audio.pause();
        audio.currentTime = 0; // Reset audio to the beginning
      }
    }, 100);
  } catch (error) {
    console.error("Error in TTS request:", error);
  }

};
